import { useTranslation } from "next-i18next";
import { sharedServerSideProps } from "@/src/utils/sharedServerSideProps";
import PageHead from "@/src/shared/PageHead";
import Separator from "@/src/shared/Separator";
import Footer from "@/src/shared/Footer";
import Header from "@/src/shared/Header/Header";
import Link from "next/link";

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <>
      <PageHead title={t("pageNotFound")} />
      <Header />
      <div className="rbt-error-area bg-gradient-11 rbt-section-gap">
        <div className="error-area">
          <div className="container">
            <div className="row justify-content-center text-center">
              <div className="col-10">
                <h1 className="title">404!</h1>
                <h3 className="sub-title">{t("pageNotFound")}</h3>
                <p>{t("pageNotFoundDescription")}</p>
                <Link className="rbt-btn btn-gradient icon-hover" href="/">
                  <span className="btn-text">{t("backToHomePage")}</span>
                  <span className="btn-icon">
                    <i className="feather-arrow-right"></i>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Separator />
      <Footer />
    </>
  );
}

export const getServerSideProps = sharedServerSideProps(async ({ res }) => {
  const statusCode = res?.statusCode || 500;
  return { props: { statusCode } };
});
